/**
 * LocalStorage
 * search paramsを削除
 */
export function removeSpaceSearchParams() {
  localStorage.removeItem('search_params')
}
